//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum REQUEST_RIGHTS {
  REQUEST_RIGHTS_CONFIGURATIONS = 'REQUEST_RIGHTS/REQUEST_RIGHTS_CONFIGURATIONS',
  RECEIVE_RIGHTS_CONFIGURATIONS = 'REQUEST_RIGHTS/RECEIVE_RIGHTS_CONFIGURATIONS',
  SELECT_CONFIGURATION_ID = 'REQUEST_RIGHTS/SELECT_CONFIGURATION_ID',
  SELECT_MESSAGE_INDEX = 'REQUEST_RIGHTS/SELECT_MESSAGE_INDEX',
  REQUEST_GRAPH_RIGHTS = 'REQUEST_RIGHTS/REQUEST_GRAPH_RIGHTS',
  REQUEST_GRAPH_RIGHTS_SUCCEEDED = 'REQUEST_RIGHTS/REQUEST_GRAPH_RIGHTS_SUCCEEDED',
  REQUEST_GRAPH_RIGHTS_FAILED = 'REQUEST_RIGHTS/REQUEST_GRAPH_RIGHTS_FAILED',
  BV_NETWORK_MSG_1 = 'One word. Love! Can we share your pic? Reply w/  #agree if you own this image, give us consent to use it in our paid, digital, social, email and with our retail partners. Replying confirms you agree to these requirements. ',
  BV_NETWORK_MSG_2 = 'Great photo! Ok if we shared it on our sites and with our retail partners ? If so, reply #agree. ',
  BV_NETWORK_MSG_3 = 'Thanks for sharing your photo! Can we share it on our sites and with our retail partners?  If so, reply #agree ',
  BV_NETWORK_MSG_4 = 'LOVE this pic! We wish to feature it on our site and/or social, email & our retail partners. If OK, reply with #agree ',
  BV_NETWORK_MSG_5 = 'Thanks for sharing your photo! Reply #agree if you agree to allow us to share on our sites, social and with our retail partners? ',
  TIKTOK_NETWORK_MSG_1 = 'Fantastic post! If you consent to us sharing it, tag us and reply with #agree.',
  TIKTOK_NETWORK_MSG_2 = 'Amazing content! To let us share it, tag us and reply with #agree.',
  TIKTOK_NETWORK_MSG_3 = 'Wonderful content! To provide consent for us to feature it, tag us and reply with #agree.',
  TIKTOK_NETWORK_MSG_4 = "Love this shot! If you're happy for us to feature it, tag us and reply with #agree.",
  TIKTOK_NETWORK_MSG_5 = "We'd love to feature this! To agree, please tag us and reply with #agree.",
}
